import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Phone, Wrench } from "lucide-react";
import { EMAIL, PHONE, waLink } from "../../lib/api";
import { Eyebrow, Reveal } from "../site/Reveal";

export const FITTING_MSG = "Hi CBLS AIRBAGS, I'd like a fitting quote. My postcode: ... My car (make, model, year or reg): ";
const IMG = "https://images.unsplash.com/photo-1638602030549-d04078ed0b90?w=1400&q=80";

export const Fitting = () => (
  <section id="fitting" data-testid="fitting-section" className="border-t border-white/10 bg-[#0B1016]">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 py-24 sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-32">
      <Reveal className="lg:col-span-5">
        <div className="clip-frame-lg relative aspect-[4/3] overflow-hidden bg-[#121820] lg:aspect-[4/5]">
          <img src={IMG} alt="Car dashboard ready for airbag fitting" loading="lazy" className="h-full w-full object-cover opacity-80" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_20%,rgba(9,13,18,0.85)_85%)]" />
          <span className="absolute bottom-5 left-5 flex items-center gap-2 rounded-full bg-[#090D12]/80 px-4 py-2 font-mono text-xs uppercase tracking-widest backdrop-blur">
            <Wrench className="h-4 w-4 text-[#F59E0B]" /> Fitting service
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Eyebrow>Fitting service</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-7xl">
          Need it fitted? <span className="text-outline">We can help.</span>
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg">
          Buying an airbag, dashboard or seat belt from us and want it fitted? Get in touch with your vehicle details and the part
          you need, and we'll talk you through fitting options and arrange a time.
        </p>
        <div data-testid="fitting-quote-info" className="mt-8 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
          <div className="bg-[#0B1016] p-5">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Price</p>
            <p className="mt-2 font-display text-3xl font-bold uppercase">Contact for a quote</p>
          </div>
          <div className="flex gap-3 bg-[#0B1016] p-5">
            <MapPin className="mt-1 h-5 w-5 shrink-0 text-[#E11D48]" />
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Area covered</p>
              <p className="mt-2 font-display text-3xl font-bold uppercase">West Midlands</p>
            </div>
          </div>
        </div>
        <div className="mt-10 grid gap-3 sm:grid-cols-2">
          <a data-testid="fitting-whatsapp-button" href={waLink(FITTING_MSG)} target="_blank" rel="noreferrer" className="flex h-14 items-center justify-center gap-2 rounded-full bg-emerald-500 font-semibold text-[#06281b] transition-colors hover:bg-emerald-400">
            <MessageCircle className="h-4 w-4" /> Get a quote on WhatsApp
          </a>
          <a data-testid="fitting-call-button" href={`tel:${PHONE}`} className="flex h-14 items-center justify-center gap-2 rounded-full bg-white font-semibold text-[#090D12] transition-transform hover:scale-[1.02]">
            <Phone className="h-4 w-4" /> Call {PHONE}
          </a>
          <a data-testid="fitting-email-button" href={`mailto:${EMAIL}?subject=${encodeURIComponent("Fitting service enquiry")}`} className="flex h-14 items-center justify-center gap-2 rounded-full border border-white/20 font-semibold transition-colors hover:border-white">
            <Mail className="h-4 w-4" /> Email us
          </a>
          <Link to="/#contact" data-testid="fitting-enquiry-button" className="flex h-14 items-center justify-center gap-2 rounded-full border border-white/20 font-semibold transition-colors hover:border-white">
            Send a fitting enquiry
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
